export function formatCustomerQuoteText(quoteText: string, quoteAccentText: string | null): string {
  if (!quoteAccentText)
    return quoteText;

  return quoteText.replace(quoteAccentText, `<b>${quoteAccentText}</b>`);
}
